import {Button, Modal} from '@mantine/core'
import {useEffect, useState} from 'react'

import API from '../../../api/APIUrl'
import {addPartners, updatePartnersById} from '../../../api/AdminAPI'
import {EDIT_ROW_COLORS} from '../../../utils/contants'
import {cancelSubmit, getRecords, handleSubmit} from '../../CommonFunction'
import ActionColumn from '../../components/ActionColumn'
import CustomTable from '../../components/CustomTable'
import {PartnerMasterInitialInput} from '../../data/AdminModuleDefaultData'
import {APIStatusData, SubmitAPIStatusData} from '../../data/OtherDefaultData'
import {useAuth} from '../../modules/auth'
import {PartnerMasterInput, PartnerMasterOutput} from '../../types/AdminModuleTypes'
import {InputErrorType, SubmitAPIStatusType} from '../../types/OtherTypes'
import PartnerForm from './PartnerForm'
import {getPartnerByID, partnerTableHeaderData, validateForm} from './PartnerFunctions'

const Partner = () => {
  const {currentUser} = useAuth()
  const [partners, setPartners] = useState<PartnerMasterOutput>({...APIStatusData, data: []})
  const [editId, setEditId] = useState<string | null>(null)
  const [inputError, setInputError] = useState<InputErrorType>({})
  const [showForm, setShowForm] = useState<boolean>(false)
  const [submitAPIStatus, setSubmitAPIStatus] = useState<SubmitAPIStatusType>(SubmitAPIStatusData)
  const [formField, setFormField] = useState<PartnerMasterInput>({
    ...PartnerMasterInitialInput,
    createdBy: currentUser?.id ?? '',
  })
  const getTableBody = () => {
    return partners?.data?.map((obj) => {
      return (
        <tr
          className={`${editId === obj?.id ? `${EDIT_ROW_COLORS} ` : ''}`}
          key={obj?.id ?? '-'}
        >
          <td>{obj?.partnerName ?? '-'}</td>
          <td>{obj?.partnerCompany ?? '-'}</td>
          <td>{obj?.email ?? '-'}</td>
          <td>{obj?.contact ?? '-'}</td>
          <td>{obj?.registerAddress ?? '-'}</td>

          <td>
            <ActionColumn
              edit={{
                onClick: () => {
                  getPartnerByID(
                    obj.id,
                    formField,
                    setFormField,
                    setEditId,
                    setInputError,
                    setShowForm
                  )
                },
              }}
              // remove={{
              //   onClick: () =>
              //     deleteRecord(
              //       `${API.PARTNER}/${obj.id}`,
              //       setPartners,
              //       setFormField,
              //       setEditId,
              //       setInputError,
              //       {...PartnerMasterInitialInput,createdBy:currentUser?.id??''},
              //       setShowForm,
              //       `${API.PARTNER}?action=${activeTab}`
              //     ),
              // }}
            />
          </td>
        </tr>
      )
    })
  }

  useEffect(() => {
    let mounted = true
    if (mounted) {
      getRecords(`${API.PARTNER}?createdBy=${currentUser?.id}`, setPartners)
    }

    return () => {
      mounted = false
    }
  }, [])
  return (
    <>
      <div>
        {' '}
        <div className='row '>
          <Modal
            opened={showForm}
            onClose={() => {
              cancelSubmit(
                setFormField,
                setEditId,
                setInputError,
                {...PartnerMasterInitialInput, createdBy: currentUser?.id ?? ''},
                setShowForm
              )
            }}
            withCloseButton={true}
            size='50rem'
          >
            <div className='col-12 mb-2 '>
              <div className='card '>
                <div className='card-header'>
                  <h4 className='card-title'>{editId !== null ? 'Update' : 'Add'} Partner</h4>
                </div>
                <div className='card-body py-2'>
                  <div className='mb-5 col-md-12'>
                    <PartnerForm
                      formField={formField}
                      setFormField={setFormField}
                      setInputError={setInputError}
                      inputError={inputError}
                    />
                  </div>
                </div>
                <div className='card-footer py-3'>
                  <div className={`d-flex flex-wrap justify-content-end align-items-center`}>
                    <Button
                      className={`btn ${'btn-secondary'} btn-sm me-2 font-weight-bold`}
                      onClick={() => {
                        cancelSubmit(
                          setFormField,
                          setEditId,
                          setInputError,
                          {...PartnerMasterInitialInput, createdBy: currentUser?.id ?? ''},
                          setShowForm
                        )
                      }}
                    >
                      Cancel
                    </Button>

                    <Button
                      className='btn btn-primary btn-sm py-1  me-2'
                      loading={submitAPIStatus.loading}
                      onClick={() => {
                        handleSubmit(
                          `${API.PARTNER}?createdBy=${currentUser?.id}`,
                          editId ? formField : {...formField},
                          {...PartnerMasterInitialInput, createdBy: currentUser?.id ?? ''},
                          setPartners,
                          setEditId,
                          setFormField,
                          editId,
                          setInputError,
                          validateForm,
                          setSubmitAPIStatus,
                          addPartners,
                          updatePartnersById,
                          setShowForm
                        )
                      }}
                    >
                      {editId !== null ? 'Update' : 'Save'}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>

          <div className='col-12 '>
            <CustomTable
              data={partners}
              setData={setPartners}
              url={`${API.PARTNER}?createdBy=${currentUser?.id}`}
              tableBody={getTableBody}
              tableHeadData={partnerTableHeaderData}
              tableLabel='Partner'
              // isPaginationRequired={false}
              // isSearchingRequired={false}
              // isSortingRequired={false}
              newRecordButton={
                <Button
                  type='button'
                  className='btn btn-primary btn-sm me-3'
                  onClick={() => setShowForm(true)}
                  hidden={showForm}
                >
                  Add Partner
                </Button>
              }
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default Partner
